var screenWidth = $(window).width(),
	oFilters,
	minPrice,
	maxPrice;

// Listen to back button
var loadPage = window.history.state;
window.onpopstate = function (event) {
	if (loadPage) {
		oFilters = getQueryStringFilters();
		getProducts();
	}
}

$(function () {
	initPaymentOptions();
	initReleaseInfo();

	// load price slider
	loadPriceSlider();

	// load pagination hrefs
	loadPaginationHrefs();

	// Close filter
	$(el('mainContainer')).on('click', '.titleHeader:not(.titleHeaderDropdown,.preventCollapse)', function (e) {
		if ($(e.target).closest('.editTranslationWrapper').length) {
			return;
		}
		if ($(this).hasClass('closed')) {
			$(this).nextAll().show();
		}
		else {
			$(this).nextAll().hide();
		}
		$(this).toggleClass('closed');
		$(this).find('.closeFilter').toggleClass('icon-angle-right');
		$(this).find('.closeFilter').toggleClass('icon-angle-down');
	});

	loadMobileFilterCollapse();

	// Set object with current selected filters
	oFilters = getQueryStringFilters();
	selectFilters();

	// Ajax refresh on filter click
	$(el('mainContainer')).on('change', '.iFacet', function () {
		updateFilter($(this), !$(this).is(':checked'));
	});

	$(el('mainContainer')).on('click', '.iFacet[type="radio"]', function ()
	{
		if ($(this).prop('checked'))
		{
			if ($(this).data('wasChecked'))
			{
				$(this).prop('checked', false).trigger('change');
			}
			$('.iFacet[type="radio"]').data('wasChecked', false);
			$(this).data('wasChecked', true);
		}
		else
		{
			$('.iFacet[type="radio"]').data('wasChecked', false);
		}
	});

	if (typeof fbq !== 'undefined') {
		// Search
		if (typeof sSearch !== 'undefined' && sSearch !== '') {
			fbq('track', 'Search');
		}
	}

	// Remove facet from selected facets
	$(el('mainContainer')).on('click', '.selectedFacet', function () {
		updateFilter($(this), true);
	});

	// Paging
	$(el('mainContainer')).on('click', '.paging', function (e) {
		e.preventDefault();

		addParam('page', $(this).data('page'));
		// Scroll up
		$("html, body").animate({ scrollTop: 0 }, 400);
	});

	// Sorting
	$(el('mainContainer')).on('change', '#frmSort select', function () {
		if ($(this).val() == '') {
			var sLocation = window.location.href;
			var sUrl = removeParam(sLocation, 'sort');
			window.history.pushState(null, document.title, sUrl);
			loadPage = true;
			getProducts();
		}
		else {
			addParam('sort', $(this).val());
			return false;
		}
	});

	// Secondary sorting (not select box)
	$(el('mainContainer')).on('click', '#sortOptions a', function () {
		if ($(this).data('value') !== '') {
			addParam('sort', $(this).data('value'));
		}
		else {
			// Empty value resets to the default sorting, like the select box does
			var sUrl = removeParam(window.location.href, 'sort');
			window.history.pushState(null, document.title, sUrl);
			loadPage = true;
			getProducts();
		}

		return false;
	});

	// Close an open sorting dropdown when clicking elsewhere
	$(document).on('click', function (e) {
		$('details.sortDropdown[open]').not($(e.target).closest('.sortDropdown')).removeAttr('open');
	});

	// Page size
	$(el('mainContainer')).on('change', '#frmPageSize select', function () {
		addParam('size', $(this).val());
		return false;
	});

	// Set min/max price
	minPrice = $('.edtPriceMin').val();
	maxPrice = $('.edtPriceMax').val();

	// Button to set price
	$(el('mainContainer')).on('click', '#btnSetPrice,.btnSetPrice', function () {
		setPrice($(this));
	});

	// Show/hide facets when more than 5
	$(el('mainContainer')).on('click', '.toggleMoreFacets', function () {
		$(this).hide().parents('ul').find('.toggleHide').show();
		$(this).parents('ul').find('.toggleLessFacets').show();
	});

	$(el('mainContainer')).on('click', '.toggleLessFacets', function () {
		$(this).hide().parents('ul').find('.toggleHide').hide();
		$(this).parents('ul').find('.toggleMoreFacets').show();
	});

	// Show/hide filters when more than X
	$(el('mainContainer')).on('click', '.toggleMoreFilters', function () {
		$(this).hide().parents('div').find('.toggleHideFilters').show();
		$(this).parents('div').find('.toggleLessFilters').show();
	});

	$(el('mainContainer')).on('click', '.toggleLessFilters', function () {
		$(this).hide().parents('div').find('.toggleHideFilters').hide();
		$(this).parents('div').find('.toggleMoreFilters').show();
	});

	$(el('mainContainer')).on('click', '.sendProductsForPicturePack', function (oEvent) {
		oEvent.preventDefault();
		$('#sendConfirmPictureFilterPackModal').modal('show');
		return false;
	});

	$('body').on('click', '#sendConfirmPictureFilterPackModal #btnSend', function (oEvent) {
		oEvent.preventDefault();
		$(this).prop('disabled', true);

		sendProductsForPicturePack($(this));
		return false;
	});

	$('body').on('click', '.listerViewShowList', function (oEvent) {
		oEvent.preventDefault();

		switchListerView('list');

		return false;
	});

	$('body').on('click', '.listerViewShowGrid', function (oEvent) {
		oEvent.preventDefault();

		switchListerView('grid');

		return false;
	});

	$(el('mainContainer')).on("click", '.jsTriggerFilters', function(e)
	{
		e.preventDefault();

		handleJsTriggerFilters();
	});

	$(el('mainContainer')).on("click", '.jsDismissFilters,.jsSubmitFilters', function(e)
	{
		e.preventDefault();

		handleJsDismissFilters();
	});

	$(el('mainContainer')).on("click", '.jsRemoveFilters', function(e)
	{
		e.preventDefault();

		removeAllFilters();
	});

	// In category search
	$(el('mainContainer')).on("keyup", '.incatsearch', function (e) {
		e.preventDefault();

		if (e.keyCode == 13) $(".searchCatSubmit").click();
	});
	$(el('mainContainer')).on("click", '.searchCatSubmit', function (e) {
		e.preventDefault();

		var oFilter = $("#incatsearch");
		if (oFilter.val() !== "") {
			oFilter.data("filter", "incatsearch");
			oFilter.data("value", oFilter.val());

			var filterIndex = oFilters.findIndex( function(obj) {
				return obj.incatsearch;
			});
			if (filterIndex > -1) oFilters.splice(filterIndex, 1);

			updateFilter(oFilter, false);
		}
	});

	// Selected filters
	$(el('mainContainer')).on("click", '#selectedFilters .selectedItem', function (e) {
		removeFilter($(this));
	});
	$(el('mainContainer')).on("click", '.selectedfilterswrapper .lbRemoveAllFilters', function (e) {
		removeAllFilters();
	});

	$(el('mainContainer')).on("click", '.productLister .thumbnail a, .detailRelated .thumbnail a, .recentlyViewedProducts .thumbnail a', function (e) {
		$(document).trigger("selectItem",[$(this).parents(".thumb").data("product")]);
		$(document).trigger("twClickProduct",[$(this).parents(".thumb").data("product")]);

		// Trigger window.open event if onclick is set on the a tag, else, trigger a href normally
		let onclickAttr = $(this).attr("onclick");
		if (onclickAttr) {
			e.preventDefault();
			new Function(onclickAttr)();
		}
	});

	$(el('mainContainer')).on('keyup','.inputSearchFacets', function(e)
	{
			var oFacets     = $(this).parents(".categories").find("ul li");
			var sSearchTerm = $(this).val().toLowerCase();

			if(sSearchTerm === '')
			{
				oFacets.show();
			}
			else
			{
				oFacets.each(function(j,facet) {
					var sValue= $(facet).find("input").data("value").toLowerCase();

					if(sValue.indexOf(sSearchTerm) < 0)
					{
						$(this).hide();
					}
					else
					{
						$(this).show();
					}
				});
			}
	});

	initTweakwiseGuidedSellingAdmin();
	initGuidedSelling();
});

function initGuidedSelling()
{
	// delegated on the persistent container: the guide block is re-rendered with every lister reload
	$(el('mainContainer')).on('click', '.jsGuidedSellingAnswer', function ()
	{
		var sUrl = removeParam(window.location.href, 'page');
		sUrl = updateQueryStringParameter(sUrl, 'qs' + $(this).data('question-id'), encodeURIComponent($(this).data('answer-id')));
		reloadGuidedSelling(sUrl);
	});

	// removing an answer also drops every answer given after it, later questions depend on it
	$(el('mainContainer')).on('click', '.jsGuidedSellingRemove', function ()
	{
		var aQuestionIds = String($(this).closest('.jsGuidedSelling').data('question-ids')).split(',');
		var iFrom = aQuestionIds.indexOf(String($(this).data('question-id')));
		var sUrl = removeParam(window.location.href, 'page');
		for (var i = Math.max(iFrom, 0); i < aQuestionIds.length; i++) {
			sUrl = removeParam(sUrl, 'qs' + aQuestionIds[i]);
		}
		reloadGuidedSelling(sUrl);
	});

	$(el('mainContainer')).on('click', '.jsGuidedSellingReset', function ()
	{
		var sUrl = removeParam(window.location.href, 'page');
		$.each(getGuidedSellingAnswers(), function (index, oAnswer) {
			sUrl = removeParam(sUrl, oAnswer.key);
		});
		reloadGuidedSelling(sUrl);
	});
}

function reloadGuidedSelling(sUrl)
{
	window.history.pushState(null, document.title, sUrl.replace(/\?$/, ''));
	loadPage = true;
	getProducts();
}

// guided selling answers in the current URL: qs<questionId>=<answerId>
function getGuidedSellingAnswers()
{
	var aAnswers = [];
	location.search.substr(1).split('&').forEach(function (sItem) {
		var aPair = sItem.split('=');
		if (/^qs[0-9]+$/.test(aPair[0]) && aPair.length > 1 && aPair[1] !== '') {
			aAnswers.push({ key: aPair[0], value: aPair[1] });
		}
	});
	return aAnswers;
}

function initTweakwiseGuidedSellingAdmin()
{
	var $root = $('.tweakwise-gs-admin');
	if (!$root.length) return;

	var categoryId = $root.attr('data-category-id');
	var $input  = $root.find('.tweakwise-gs-admin-code');
	var $body   = $root.find('.tweakwise-gs-admin-body');
	var $status = $root.find('.tweakwise-gs-admin-status');

	function setStatus(type, message)
	{
		var cssClass = (type === 'success') ? 'alert alert-success' : (type === 'error') ? 'alert alert-error' : 'alert alert-info';
		$status.html('<div class="' + cssClass + '" style="margin:0; padding:6px 10px; font-size:12px;">' + message + '</div>');
	}

	function submit(code)
	{
		setStatus('info', '<i class="fa fa-spinner fa-spin"></i> Saving...');
		uAjax = '/index.cfm/product/ajax/setguidedsellingnavigation';
		var sParams = '&categoryId=' + encodeURIComponent(categoryId) + '&code=' + encodeURIComponent(code);
		var oCall = callAjax('setguidedsellingnavigation', sParams, 'post');
		oCall.success(function(oData)
		{
			if (oData.errorType === '')
			{
				setStatus('success', 'Saved. Reload to see the change.');
			}
			else
			{
				$status.empty();
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}

	$root.find('.tweakwise-gs-admin-save').on('click', function() { submit($input.val() || ''); });
	$root.find('.tweakwise-gs-admin-clear').on('click', function() { $input.val(''); submit(''); });
	$root.find('.tweakwise-gs-admin-toggle').on('click', function() { $body.toggle(); });
}

function handleJsTriggerFilters(oEl)
{
	$('.jsProductFilters').addClass('jsProductFiltersActive');
	$('.jsDismissFilters').show();

	$('html, body').animate({ scrollTop: 0 }, 0);
	$('html, body').css({'overflow':'hidden', 'position': 'relative', 'height':'100%'});
}

function handleJsDismissFilters(oEl)
{
	$('.jsProductFilters').removeClass('jsProductFiltersActive');
	$('.jsDismissFilters').hide();

	$('html, body').css({'overflow':'visible', 'position': 'static', 'height':'auto'});
}

function initReleaseInfo()
{
	var oThumbsReleaseInfo = $(el('mainContainer')).find(".thumb .releaseInfo:not(.disabled)");

	if(oThumbsReleaseInfo.length > 0)
	{
		var releaseProductIds = [];
		oThumbsReleaseInfo.each(function () {
			releaseProductIds.push($(this).parents(".thumb").data("product"));
		});

		loadReleaseInfo(releaseProductIds);
	}

	// dont get disabled preorder thumbs
	var oThumbsReleaseDisabled = $(el('mainContainer')).find(".thumb .releaseInfo.disabled");
	if(oThumbsReleaseDisabled.length > 0)
	{
		oThumbsReleaseDisabled.each(function () {
			var oThumb = $(this).parents(".thumb");
			var sReleaseInfoTitle = (typeof sReleaseInfoTitleUnavailable !== "undefined") ? sReleaseInfoTitleUnavailable:"";
			var sReleaseInfo = (typeof sReleaseInfoUnavailable !== "undefined") ? sReleaseInfoUnavailable : "";

			oThumb.find(".releaseInfo").append("<h3>"+ sReleaseInfoTitle + "</h3>");
			oThumb.find(".releaseInfo").append("<p>"+ sReleaseInfo + "</p>");
			oThumb.find(".thumbButtons .btn").removeClass("btn-gm-yellow").addClass("btn-gm-grey");
		});
	}
}

function loadReleaseInfo(releaseProductIds)
{
	uAjax = "/index.cfm/product/ajax/getreleaseinfo";

	var sParams = '&productIds=' + JSON.stringify(releaseProductIds);
	var oCall   = callAjax("getreleaseinfo", sParams, "post");
	oCall.success(function (oData)
	{
		if (oData.errorType == '' && oData.releaseInfo !== "")
		{
			$.each(oData.releaseInfo, function( index, product ) {
				var bPreorderAvailable = (product.preorderStock > 0 && !product.stopPreorder)
				var sReleaseInfoTitle = (bPreorderAvailable) ? (typeof sReleaseInfoTitleAvailable !== "undefined") ? sReleaseInfoTitleAvailable:"" : (typeof sReleaseInfoTitleUnavailable !== "undefined") ? sReleaseInfoTitleUnavailable:"";
				var sReleaseInfo = (bPreorderAvailable) ? (typeof sReleaseInfoAvailable !== "undefined") ? sReleaseInfoAvailable : "" : (typeof sReleaseInfoUnavailable !== "undefined") ? sReleaseInfoUnavailable : "";
				var sReleaseAction = (bPreorderAvailable) ? (typeof sReleaseActionAvailable !== "undefined") ? sReleaseActionAvailable : "" : "";
				var sReleaseStock = (product.stopPreorder) ? (typeof sReleaseInfoNoStock !== "undefined") ? sReleaseInfoNoStock : "" : "";

				var oThumb = $(el('mainContainer')).find(".thumb[data-product=" + product.productId + "]");
				oThumb.find(".releaseInfo").append("<h3>"+ sReleaseInfoTitle + "</h3>");
				oThumb.find(".releaseInfo").append("<p>"+ sReleaseInfo + "</p>");
				oThumb.find(".releaseInfo").append("<p>"+ sReleaseStock + "</p>");
				oThumb.find(".releaseInfo").append("<p>"+ sReleaseAction + "</p>");

				if(!bPreorderAvailable)
				{
					oThumb.find(".thumbButtons .btn").removeClass("btn-gm-yellow").addClass("btn-gm-grey");
				}
			});
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function switchListerView(type) {
	if (type === 'list') {
		$('body').find('.thumb.thumbListerView').removeClass('span4').addClass('listView').addClass('span12');
		$('body').find('.listerViewShowList').addClass('active');
		$('body').find('.listerViewShowGrid').removeClass('active');
	}
	else {
		$('body').find('.thumb.thumbListerView').removeClass('span12').removeClass('listView').addClass('span4');
		$('body').find('.listerViewShowList').removeClass('active');
		$('body').find('.listerViewShowGrid').addClass('active');
	}

	var sParams = "&type=" + type;

	var oCall = callAjax("switchListerView", sParams, "post", "/index.cfm/product/ajax/switchlisterview");

	// process feedback
	oCall.success(function (oData) {
		if (oData.errorType === 'loggedOut') {
			location.reload();
		}
		else if (oData.errorType !== '') {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function sendProductsForPicturePack(button) {
	if (iNavigationId != -1) {
		var sParams = '&id=' + iNavigationId;
	}
	else {
		var sParams = '&keyword=' + sSearch;
	}

	var sFilters = getQueryParam('filters');
	var sFeatures = getQueryParam('features');
	var sSize = getQueryParam('size');
	var sSort = getQueryParam('sort');
	var sPage = getQueryParam('page');

	if (sFilters !== 'filters') {
		sParams += '&filters=' + sFilters;
	}
	if (sFeatures !== 'features') {
		sParams += '&features=' + sFeatures;
	}
	if (sSize !== 'size') {
		sParams += '&size=' + sSize;
	}
	if (sSort !== 'sort') {
		sParams += '&sort=' + sSort;
	}
	if (sPage !== 'page') {
		sParams += '&page=' + sPage;
	}
	if (typeof aIds !== 'undefined') {
		sParams += '&ids=' + aIds;
	}

	$('.titleHeader').each(function () {
		if (typeof $(this).data('element') !== 'undefined') {
			sParams += '&visible' + $(this).data('element') + '=' + !$(this).hasClass('closed');
		}
	});

	sParams += "&email=" + button.closest('.modal').find('.picturePackEmail').val();

	var oCall = callAjax("sendProductsForPicturePack", sParams, "post", "/index.cfm/customer/ajax/sendProductsForPicturePack");

	// process feedback
	oCall.success(function (oData) {
		if (oData.errorType === 'info') {
			button.closest('.modal').modal('hide');
			button.prop('disabled', false);
			inlineAlert('info', oData.errorMessage, false, '.sendProductsForPicturePack');
		}
		else if (oData.errorType === 'loggedOut') {
			location.reload();
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			button.prop('disabled', false);
		}
	});
}

function addParam(type, value) {
	var oParam = {};
	oParam[type] = value;
	var sLocation = getParamLocation(type, oParam);

	window.history.pushState(null, document.title, sLocation);
	loadPage = true;
	getProducts();
}

function buildURL() {
	var sQueryString = '';
	var sQueryStringFeatures = '';
	var sQueryStringWishlistFilters = '';

	if (oFilters.length === 0) {
		var sUrl = removeParam(window.location.href, 'filters');
		sUrl = removeParam(sUrl, 'features');
		sUrl = removeParam(sUrl, 'wishlist');
		window.history.pushState(null, document.title, sUrl);
		loadPage = true;
	}
	else {
		var filterFields = ["size", 'colours', 'price_current', 'price_used', 'instock'];
		var wishlistFilterFields = ["properties"];
		for (var i = 0; i < oFilters.length; i++) {
			var sFilterName = Object.keys(oFilters[i])[0];
			if (filterFields.indexOf(sFilterName.toLowerCase()) > -1) {
				if (sQueryString !== '') {
					sQueryString += ';';
				}
				sQueryString += sFilterName + encodeURIComponent('|') + oFilters[i][sFilterName].join();
			}
			else if (wishlistFilterFields.indexOf(sFilterName.toLowerCase()) > -1) {
				if (sQueryStringWishlistFilters !== '') {
					sQueryStringWishlistFilters += ';';
				}
				sQueryStringWishlistFilters += sFilterName + encodeURIComponent('|') + oFilters[i][sFilterName].join();
			}
			else {
				if (sQueryStringFeatures !== '') {
					sQueryStringFeatures += ';';
				}
				sQueryStringFeatures += sFilterName + encodeURIComponent('|') + oFilters[i][sFilterName].join();
			}
		}
		var sUrl = window.location.href;
		if (sQueryString !== '') {
			sUrl = updateQueryStringParameter(sUrl, 'filters', sQueryString);
		}
		else {
			sUrl = removeParam(sUrl, 'filters');
		}
		if (sQueryStringFeatures !== '') {
			sUrl = updateQueryStringParameter(sUrl, 'features', sQueryStringFeatures);
		}
		else {
			sUrl = removeParam(sUrl, 'features');
		}
		if (sQueryStringWishlistFilters !== '') {
			sUrl = updateQueryStringParameter(sUrl, 'wishlist', sQueryStringWishlistFilters);
		}
		else {
			sUrl = removeParam(sUrl, 'wishlist');
		}

		sFacetStates = getFacetStates();

		window.history.pushState(null, document.title, sUrl);
		loadPage = true;
	}
}

function setSelectedFilters() {
	// Check if theme supports selected filters
	var filterSelected = false;
	if ($("#selectedFilters").length > 0) {
		$("#selectedFilters").html("");
		// Loop through filters and output them
		$(".productFilters .categories").each(function (index, filter) {
			$(filter).find(".iFacet:checked").each(function (index, option) {
				// Add to selected
				$("#selectedFilters").append("<span class='selectedItem' data-filter='" + $(filter).find(".titleHeader").data("element") + "'>" + $(option).parent().find(".facetKey").text() + "</span>");
				filterSelected = true;
			});
		});
	}
	if (filterSelected) {
		$(".selectedfilterswrapper").show();
	} else {
		$(".selectedfilterswrapper").hide();
	}
	dropdownFilters();
}

function getFacetStates() {
	$('.productFilters .categories, .productFilters .pro-range-slider').each(function () {
		if (typeof $(this).data('element') !== 'undefined') {
			sParams += '&visible' + $(this).data('element') + '=' + !$(this).hasClass('closed');
		}
	});
}

function collapseFilters(heading) {
	$('.filterContent').slideToggle(200);
	heading.find('.closeFacets').toggleClass('icon-angle-right');
	heading.find('.closeFacets').toggleClass('icon-angle-down');
}

function getParamLocation(sType, oParam) {
	var sLocation = window.location.href;
	sLocation = removeParam(sLocation, sType);
	if (sType === 'size') {
		sLocation = removeParam(sLocation, 'page');
	}

	sLocation += (sLocation.indexOf('?') >= 0 ? '&' : '?') + $.param(oParam);

	return sLocation;
}

function getProducts()
{
	var bWishlist = (typeof sCurrentModule !== "undefined" && sCurrentModule == "wishlist");

	$(el('loader')).toggleClass('hidden').find('i').center();
	if (iNavigationId != -1) {
		var sParams = '&id=' + iNavigationId;
	}
	else {
		var sParams = '&keyword=' + encodeURIComponent(sSearch);
	}

	var sFilters = getQueryParam('filters');
	var sFeatures = getQueryParam('features');
	var sWishlistFilters = getQueryParam('wishlist');
	var sSize = getQueryParam('size');
	var sSort = getQueryParam('sort');
	var sPage = getQueryParam('page');

	if (sFilters !== 'filters') {
		sParams += '&filters=' + sFilters;
	}
	if (sWishlistFilters !== 'wishlist') {
		sParams += '&wishlist=' + sWishlistFilters;
	}
	if (sFeatures !== 'features') {
		sParams += '&features=' + sFeatures;
	}
	if (sSize !== 'size') {
		sParams += '&size=' + sSize;
	}
	if (sSort !== 'sort') {
		sParams += '&sort=' + sSort;
	}
	if (sPage !== 'page') {
		sParams += '&page=' + sPage;
	}
	$.each(getGuidedSellingAnswers(), function (index, oAnswer) {
		sParams += '&' + oAnswer.key + '=' + oAnswer.value;
	});
	if (typeof aIds !== 'undefined') {
		sParams += '&ids=' + aIds;
	}

	aFacetStates = [];
	$('.titleHeader').each(function () {
		if (typeof $(this).data('element') !== 'undefined') {
			var oFacetState = {};
			oFacetState.element = $(this).data('element');
			oFacetState.visible = !$(this).hasClass('closed');
			var iFacetsCount = $(this).parent().find('.iFacet').length;
			oFacetState.viewAll = (iFacetsCount > 5 && !$(this).parent().find('.toggleMoreFacets').is(':visible'));
			aFacetStates.push(oFacetState);

			sParams += '&visible' + $(this).data('element') + '=' + !$(this).hasClass('closed');
		}
	});

	if ($('.jsProductFilters').length > 0 && $('.jsProductFilters').hasClass('jsProductFiltersActive')) {
		sParams += '&jsProductFiltersActive=true';
	}

	if(bWishlist)
	{
		sParams += '&wishlistRoute=' + sWishlistRoute;
	}

	uAjax = (bWishlist) ? "/index.cfm/wishlist/ajax/products" : "/index.cfm/product/ajax/products";
	var oCall = callAjax("products", sParams, "post");

	// process result
	oCall.success(function (oData) {
		if (oData.errorType == '') {
			$(('.outerContainer')).replaceWith(oData.html);
			selectFilters();
			ciResponsive.process();
			$('.edtPriceMin').val(minPrice);
			$('.edtPriceMax').val(maxPrice);
			loadPriceSlider();
			loadPaginationHrefs();
			loadFacetStates(aFacetStates);
			if (typeof initContentEventHandlers === "function") initContentEventHandlers();
			setSelectedFilters();
			loadExternals();
			if (typeof initPaymentOptions === "function") initPaymentOptions();
			initReleaseInfo();
			if (typeof initFlexSliders === "function") initFlexSliders();
			loadMobileFilterCollapse();
		}
		else {
			// there was an error
			showAlert('error', oData.errorMessage, oData.unhandled);
			$(el('loader')).toggleClass('hidden');
		}
	});
}

function getQueryStringFilters() {
	var vars = [], hash, result = '', aFilterList = [];
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1);
	if (typeof navFilters !== "undefined" && navFilters !== "" && hashes.indexOf(navFilters.replace(/\=/g,encodeURIComponent('|')).replace(/\&/g, ';')) == -1) {
		if (hashes.indexOf('http') == -1) {
			hashes = hashes + "&" + navFilters;
		} else {
			hashes = navFilters;
		}

	} else {
		navFilters = "";
	}
	if (hashes.indexOf('http') == -1) {
		hashes = hashes.split('&');
		for (var i = 0; i < hashes.length; i++) {
			if (hashes[i].indexOf('filters') > -1 || hashes[i].indexOf('features') > -1 || hashes[i].indexOf('wishlist') > -1) {
				var sFilters = hashes[i].split('=')[1];
				var aFilterValues = sFilters.split(';');
				for (var j = 0; j < aFilterValues.length; j++) {
					var sFilterName = aFilterValues[j].replace("%7C","|").split('|')[0];
					if (sFilterName !== "keyword") {
						var sFilterValue = aFilterValues[j].replace("%7C","|").split('|')[1];
						var oFilter = {};
						oFilter[sFilterName] = sFilterValue.split(',');
						for (var k = 0; k < oFilter[sFilterName].length; k++) {
							oFilter[sFilterName][k] = oFilter[sFilterName][k];
						}
						aFilterList.push(oFilter);
					}
				}
			} else {
				// Add navigation filters
				var sFilterName = hashes[i].split("=")[0];
				if (sFilterName !== "keyword" && navFilters.indexOf(sFilterName) > -1 && sFilterName !== "") {
					var sFiltervalue = hashes[i].split("=")[1];
					var oFilter = {};
					oFilter[sFilterName] = sFiltervalue.split(',');
					aFilterList.push(oFilter);
				}
			}
		}
	}

	return aFilterList;
}

function getQueryParam(param) {
	location.search.substr(1)
		.split("&")
		.some(function (item) { // returns first occurence and stops
			return item.split("=")[0] == param && (param = item.split("=")[1])
		})
	return param
}

function loadExternals()
{
	if(typeof googletag !== "undefined")
	{
		googletag.cmd.push(function() { googletag.pubads().refresh(); });
	}
}

function loadFacetStates(aFacetStates) {
	$.each(aFacetStates, function (index, state) {
		var oFacetState = $('.titleHeader[data-element="' + state.element + '"]');

		if (!oFacetState.hasClass('closed') && $(this).visible == false) {
			oFacetState.trigger('click');
		}
		else if (oFacetState.hasClass('closed') && state.visible == true) {
			oFacetState.trigger('click');
		}
		if (oFacetState.parent().find('.toggleMoreFacets').length > 0 && state.viewAll) {
			oFacetState.parent().find('.toggleMoreFacets').trigger('click');
		}
	});

	if ($('.filterContent .btn-collapse[data-target="#productFiltersCollapse"]').length > 0 && $('.filterContent .btn-collapse[data-target="#productFiltersCollapse"]').is(':visible')) {
		$('.filterContent .btn-collapse[data-target="#productFiltersCollapse"]').trigger('click');
	}
}

function loadMobileFilterCollapse() {
	if (WURFL.is_mobile || screenWidth < 768) {

		// Toggle collapse filters (only mobile)
		$(el('filterHeading')).on('click', function () {
			collapseFilters($(this));
		});

		// Collapse filters by default
		$('.titleHeader:not(.jsTitleHeader)').each(function () {
			if (!$(this).hasClass('closed')) {
				$(this).find('.closeFilter').toggleClass('icon-angle-right');
				$(this).find('.closeFilter').toggleClass('icon-angle-down');
				$(this).toggleClass('closed');
				$(this).nextAll().slideUp();
			}
		});
	}
}

function loadPaginationHrefs() {
	$('.pagination ul li a, .pagination > .pagingArrow').each(function () {
		if (typeof $(this).data('page') !== "undefined") {
			$(this).attr("href", getParamLocation('page', { page: $(this).data('page') }));
		}
	});
}

function loadPriceSlider() {
	// A selection travels in `filters` for the ES facets and in `features` for the Tweakwise ones.
	// Reading only `filters` left the Tweakwise slider reopening at the facet bounds instead of the
	// range the URL asks for.
	var aFilters = [];
	$.each(["filters", "features"], function (index, sParam) {
		var sValue = getUrlParameter(sParam);
		if (sValue !== "") {
			aFilters = aFilters.concat(sValue.split(';'));
		}
	});

	$.each(aFilters, function (index, value) {
		var sFilterName = value.split("|")[0];

		// The price facet is not always named price_current — Tweakwise names it after the
		// attribute (ae-price) — so ask the rendered slider what it posts under.
		var oPriceValue = $('.priceDataValue').filter(function () {
			return String($(this).data('filter')) === sFilterName;
		});

		if (sFilterName === "price_current" || sFilterName === "price_used" || oPriceValue.length > 0) {
			var sFilterValue = value.split("|")[1];
			$('.iFacet[data-filter="'+sFilterName+'"]').siblings('.edtSelectedPriceMin').val(sFilterValue.split("-")[0]);
			$('.iFacet[data-filter="'+sFilterName+'"]').siblings('.edtSelectedPriceMax').val(sFilterValue.split("-")[1]);
		}
	});

	$('.pro-range-slider').each(function(elem){
		$(this).find("#frmPriceSlider").submit(function(e){e.preventDefault(); return false;});

		// Set slider values
		var priceMin = Math.floor(parseFloat($(this).find('.edtPriceMin').val()));
		var priceMax = Math.ceil(parseFloat($(this).find('.edtPriceMax').val()));

		if((priceMax - priceMin) > 1)
		{
			var selectedPriceMin = Math.floor(parseFloat($(this).find('.edtSelectedPriceMin').val()));
			var selectedPriceMax = Math.ceil(parseFloat($(this).find('.edtSelectedPriceMax').val()));

			// Set slides
			var $slideRange = $(this).find("#slider-range");
			amount = $(this).find("#amount" );
			amountMin = $(this).find('.edtSetPriceMin');
			amountMax = $(this).find('.edtSetPriceMax');

			// Optional split min/max inputs, rendered by the theme instead of #amount
			var priceInputMin = $(this).find('.priceInputMin');
			var priceInputMax = $(this).find('.priceInputMax');

			var currency = $(this).find('.edtCurrency').val();

			$slideRange.slider({
				range: true,
				min: priceMin,
				max: priceMax,
				step: 1,
				create: function( event, ui )
				{
					// The selected range, not the facet bounds: seeding the hidden fields with the
					// bounds meant a slider reopened from a filtered URL posted the full range back
					// the moment anything else on the page triggered setPrice().
					amountMin.val(selectedPriceMin);
					amountMax.val(selectedPriceMax);
					amount.val( currency + selectedPriceMin + " - " + currency + selectedPriceMax );
					priceInputMin.val(selectedPriceMin);
					priceInputMax.val(selectedPriceMax);
					$slideRange.slider("option" , "values", [selectedPriceMin , selectedPriceMax]);
				},
				slide: function( event, ui )
				{
					amount.val( currency + ui.values[ 0 ] + " - " + currency + ui.values[ 1 ] );
					amountMin.val(ui.values[ 0 ]);
					amountMax.val(ui.values[ 1 ]);
					priceInputMin.val(ui.values[ 0 ]);
					priceInputMax.val(ui.values[ 1 ]);
				},
				stop: function( event, ui )
				{
					setPrice();
				}
			});

			if (priceInputMin.length > 0 && priceInputMax.length > 0) {
				priceInputMin.add(priceInputMax).on('change', function () {
					var iMin = parseInt(priceInputMin.val(), 10);
					var iMax = parseInt(priceInputMax.val(), 10);

					iMin = isNaN(iMin) ? priceMin : Math.min(Math.max(iMin, priceMin), priceMax);
					iMax = isNaN(iMax) ? priceMax : Math.min(Math.max(iMax, iMin), priceMax);

					priceInputMin.val(iMin);
					priceInputMax.val(iMax);
					amount.val(currency + iMin + " - " + currency + iMax);
					amountMin.val(iMin);
					amountMax.val(iMax);
					$slideRange.slider("option", "values", [iMin, iMax]);

					setPrice();
				}).on('keydown', function (e) {
					if (e.which === 13) {
						$(this).trigger('blur');
					}
				});
			}

			if($(this).find('.btnSetPrice').length > 0 || $(this).find('#btnSetPrice').length > 0)
			{
				amountMin.val(selectedPriceMin);
				amountMax.val(selectedPriceMax);
			}
		}
		else
		{
			$(this).hide();
		}
	});
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function removeParam(sourceURL, key) {
	var rtn = sourceURL.split("?")[0],
		param,
		params_arr = [],
		queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === key) {
				params_arr.splice(i, 1);
			}
		}
		rtn = rtn + "?" + params_arr.join("&");
	}
	return rtn;
}

function removeFilter(item) {
	var filter = item.data("filter");
	var description = item.text();

	// Find matching filter and deselect
	var element = $(".titleHeader[data-element='" + filter + "']").closest(".categories").find(".facetKey").filter(function () { return $(this).text() == description });
	if(element.length) element.click();
}

function removeAllFilters()
{
	oFilters = [];

	// Build URL and get products
	buildURL();
	getProducts();
}

function dropdownFilters() {
	$('.productFiltersDropdown .titleHeaderDropdown').each(function () {
		$(this).addClass('dropdown-toggle');
		$(this).attr("data-toggle", "dropdown");
		$(this).siblings("ul").addClass("dropdown-menu");
	});

	$(el('mainContainer')).on('click', '.productFiltersDropdown .dropdown-menu ', function (e) {
		e.stopPropagation();
	});
}

function selectFilters() {
	// First clear all filters (browser caches selected checkboxes)
	$('.productFilters input').prop('checked', false);

	var sFilter = '';
	var sFilterKey = '';
	var sFilterValue = '';
	for (var i = 0; i < oFilters.length; i++) {
		sFilterKey = Object.keys(oFilters[i])[0];
		sFilter = decodeURIComponent(Object.keys(oFilters[i])[0]);

		$('.productFilters input[data-filter="' + sFilter + '"]').each(function () {
			var sCommaEscape = decodeURIComponent($(this).data('value')).toString().replace(/,/g, ',,');
			$(this).attr('data-value-decoded', sCommaEscape);
		});

		for (var j = 0; j < oFilters[i][sFilterKey].length; j++) {
			sFilterValue = oFilters[i][sFilterKey][j];

			oInput = $('.productFilters input[data-filter="' + sFilter + '"][data-value-decoded="' + decodeURIComponent(sFilterValue) + '"]');
			oInput.prop('checked', true);
			oInput.parents('li').addClass('selectedFacetListItem');
		}

		if (sFilter == 'colours' || sFilter == 'ae-kleur' || sFilter == 'ae-color') {
			// loop through swatches to select the correct one
			$('.hProductItems .swatch').each(function () {
				var colour = $(this).prop('alt');
				if (typeof colour !== "undefined" && colour.toString().toLowerCase() == sFilterValue.toString().toLowerCase()) {
					$(this).trigger('click');
				}
			});
		}

		if (sFilter == "incatsearch") $("#incatsearch").val(sFilterValue);

		$('.productFilters .titleHeader[data-element="' + sFilter + '"]').find('.activeFilterAmount').html('<span class="activeFilterAmountContent">' + oFilters[i][sFilterKey].length + '</span>');
	}
	setSelectedFilters();
}

function setPrice(source) {

	if (typeof source !== 'undefined') {
		form = source.closest("form");
	} else {
		form = $("#frmPriceSlider");
	}
	if (parseFloat(form.find('.edtSetPriceMax').val()) > parseFloat(form.find(".edtPriceMax").val())) {
		form.find('.edtSetPriceMax').val(form.find(".edtPriceMax").val());
	}

	var min = (form.find('.edtSetPriceMin').val() !== "") ? form.find('.edtSetPriceMin').val() : "0";
	var max = (form.find('.edtSetPriceMax').val() !== "") ? form.find('.edtSetPriceMax').val() : "0";
	form.find('.priceDataValue').data('value', min + '-' + max);

	var sPriceFacet = String(form.find('.priceDataValue').data('filter'));

	for (var i = 0; i < oFilters.length; i++) {
		var facetCode = Object.keys(oFilters[i])[0];
		if (facetCode === 'price_current' || facetCode == "price_used" || facetCode === sPriceFacet) {
			// remove filter
			oFilters.splice(i, 1);
		}
	}

	updateFilter(form.find('.priceDataValue'), false);
}

function updateFilter(oFilter, bRemove) {
	var sFilterName = encodeURIComponent(decodeURIComponent(oFilter.data('filter')));
	var sFilterValue = encodeURIComponent(decodeURIComponent(oFilter.data('value')).replace(/,/g, ",,"));

	var filterFound = false;

	for (var i = 0; i < oFilters.length; i++) {
		if (Object.keys(oFilters[i])[0] === sFilterName) {
			if (bRemove) {
				if (oFilters[i][sFilterName].length === 1) {
					// remove filter
					oFilters.splice(i, 1);
				}
				else {
					// Remove filter value
					for (var j = 0; j < oFilters[i][sFilterName].length; j++) {
						if (oFilters[i][sFilterName][j] === sFilterValue) {
							oFilters[i][sFilterName].splice(j, 1);
						}
					}
				}
			}
			else if (oFilter.is(':radio')) {
				// Add filter
				oFilters[i][sFilterName][0] = sFilterValue;
			}
			else {
				// Add filter
				oFilters[i][sFilterName].push(sFilterValue);
			}
			filterFound = true;
		}
	}
	if (!filterFound) {
		// Add new filter
		var oFilterNew = {};
		var aFilterValue = [sFilterValue];
		oFilterNew[sFilterName] = aFilterValue;
		oFilters.push(oFilterNew);
	}
	// Remove page param
	var sLocation = removeParam(window.location.href, 'page');
	window.history.pushState(null, document.title, sLocation);
	loadPage = true;

	// Build URL and get products
	buildURL();
	getProducts();
}

function updateQueryStringParameter(uri, key, value) {
	var re = new RegExp("([?|&])" + decodeURIComponent(key) + "=.*?(&|#|$)", "i");
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	} else {
		var hash = '';
		if (uri.indexOf('#') !== -1) {
			hash = uri.replace(/.*#/, '#');
			uri = uri.replace(/#.*/, '');
		}
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		return uri + separator + key + "=" + value + hash;
	}
}

// ---------------------------------------------------------------------------------------------
// ECOMMA-4179: lister category chips collapse to a single row behind a plus.
// The overflowing chips are hidden rather than the row being clipped, so the button always sits
// immediately after the last visible chip instead of being pinned to the right edge. Expanding is
// one-way: the chips come back and the button goes away, which is the pre-ticket layout.
// Inert unless the theme renders .horizontalFacetsToggle, so the five other themes that share the
// .horizontal-facets markup are untouched.
// ---------------------------------------------------------------------------------------------
(function()
{
	var sContainer = '.productFilters.horizontal-facets';

	function syncFacetRow()
	{
		var oContainer = document.querySelector(sContainer);
		if(!oContainer) { return; }

		var oToggle = oContainer.querySelector('.horizontalFacetsToggle');
		if(!oToggle) { return; }

		var aChips = Array.prototype.slice.call(oContainer.querySelectorAll('a'));
		if(!aChips.length) { return; }

		function showAllChips()
		{
			for(var i = 0; i < aChips.length; i++) { aChips[i].classList.remove('isHiddenChip'); }
		}

		// desktop only - mobile already scrolls this row sideways, so nothing is hidden there.
		// Checked on every run so resizing across the breakpoint puts the chips back.
		if(window.matchMedia('(max-width: 767px)').matches)
		{
			showAllChips();
			oContainer.classList.remove('hasOverflow');
			return;
		}

		// expanded is final: every chip back, no button
		if(oContainer.classList.contains('isExpanded'))
		{
			showAllChips();
			oContainer.classList.remove('hasOverflow');
			return;
		}

		// measure with everything on screen, button included - its width is part of what has to fit
		showAllChips();
		oContainer.classList.add('hasOverflow');

		var oStyle    = window.getComputedStyle(oContainer);
		var iGap      = parseFloat(oStyle.columnGap || oStyle.gap) || 0;
		var iWidth    = oContainer.clientWidth - parseFloat(oStyle.paddingLeft) - parseFloat(oStyle.paddingRight);
		var aWidths   = [];
		var iTotal    = 0;
		for(var i = 0; i < aChips.length; i++)
		{
			aWidths[i] = aChips[i].offsetWidth;
			iTotal += aWidths[i] + (i ? iGap : 0);
		}

		// they all fit on their own: no button, nothing hidden
		if(iTotal <= iWidth)
		{
			oContainer.classList.remove('hasOverflow');
			return;
		}

		var iToggleWidth = oToggle.offsetWidth;
		var iUsed        = 0;
		var iFit         = 0;
		for(var i = 0; i < aChips.length; i++)
		{
			var iChip = aWidths[i] + (i ? iGap : 0);
			if(iUsed + iChip + iGap + iToggleWidth > iWidth) { break; }
			iUsed += iChip;
			iFit++;
		}
		// a single chip wider than the row would otherwise hide everything
		if(iFit < 1) { iFit = 1; }

		for(var i = 0; i < aChips.length; i++)
		{
			aChips[i].classList.toggle('isHiddenChip', i >= iFit);
		}
	}

	$(document).on('click', '.horizontalFacetsToggle', function(e)
	{
		e.preventDefault();
		var oContainer = $(this).closest(sContainer)[0];
		if(!oContainer) { return; }
		oContainer.classList.add('isExpanded');
		syncFacetRow();
	});

	var iFacetResizeTimer;
	$(window).on('resize', function()
	{
		clearTimeout(iFacetResizeTimer);
		iFacetResizeTimer = setTimeout(syncFacetRow, 150);
	});

	$(function(){ syncFacetRow(); });
	// chips are plain text, but a late webfont swap changes their width
	$(window).on('load', syncFacetRow);
})();
